<div class="my-tickets-page">

  <!-- Page Header -->
<div class="page-header">

  <!-- Mobile Back Button -->
  <button class="mobile-back-btn" type="button" (click)="goBack()">
    <span class="material-symbols-outlined">arrow_back</span>
  </button>

  <div class="header-left">
      <div class="header-icon">
        <span class="material-symbols-outlined">inbox</span>
      </div>
      <div>
        <h1>My Support Tickets</h1>
        <p>Track and manage your support requests</p>
      </div>
    </div>
    <a routerLink="/support" class="btn-new-ticket">
      <span class="material-symbols-outlined">add</span>
      New Ticket
    </a>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="loading">
    <span class="material-symbols-outlined spin">progress_activity</span>
    <p>Loading your tickets...</p>
  </div>

  <!-- Content Layout -->
  <div class="tickets-layout" *ngIf="!loading">

    <!-- LEFT PANEL: Ticket List -->
    <div class="tickets-list-panel" [class.panel-hidden]="selectedTicket">

      <!-- Filter Tabs (horizontal scroll) -->
      <div class="filter-tabs">
        <button
          *ngFor="let s of statuses"
          class="filter-tab"
          [class.active]="statusFilter === s"
          (click)="statusFilter = s">
          {{ s === 'ALL' ? 'All' : s }}
          <span class="count-bubble" *ngIf="getStatusCount(s) > 0">{{ getStatusCount(s) }}</span>
        </button>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="filteredTickets.length === 0">
        <span class="material-symbols-outlined">mark_email_read</span>
        <h3>No tickets found</h3>
        <p>{{ statusFilter === 'ALL' ? 'You haven\'t submitted any support tickets yet.' : 'No tickets with status: ' + statusFilter }}</p>
        <a routerLink="/support" class="btn-new-ticket-sm">Submit a Ticket</a>
      </div>

      <!-- Ticket Cards -->
      <div class="ticket-card-list">
        <div
          *ngFor="let ticket of filteredTickets"
          class="ticket-card"
          [class.card-active]="selectedTicket?.ticket_id === ticket.ticket_id"
          [class.card-unread]="ticket.user_unread_count > 0"
          (click)="openTicket(ticket)">

          <div class="card-top">
            <div class="cat-icon-wrap">
              <span class="material-symbols-outlined">{{ getCategoryIcon(ticket.category) }}</span>
            </div>
            <div class="card-info">
              <div class="ticket-id-label">{{ ticket.ticket_id }}</div>
              <div class="ticket-subject">{{ ticket.subject }}</div>
              <div class="ticket-category">{{ ticket.category }}</div>
            </div>
            <div class="unread-dot" *ngIf="ticket.user_unread_count > 0">{{ ticket.user_unread_count }}</div>
          </div>

          <div class="card-footer">
            <span class="status-badge" [ngClass]="getStatusClass(ticket.status)">{{ ticket.status }}</span>
            <span class="priority-badge" [ngClass]="getPriorityClass(ticket.priority)">{{ ticket.priority }}</span>
            <span class="date-label">{{ ticket.updated_at | date:'d MMM, h:mm a' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT PANEL: Ticket Thread -->
    <div class="ticket-thread-panel" [class.panel-visible]="selectedTicket">

      <!-- Thread Header -->
      <div class="thread-header" *ngIf="selectedTicket">
        <button class="btn-back" (click)="closePanel()">
          <span class="material-symbols-outlined">arrow_back</span>
        </button>
        <div class="thread-header-info">
          <div class="thread-ticket-id">{{ selectedTicket.ticket_id }}</div>
          <div class="thread-subject">{{ selectedTicket.subject }}</div>
        </div>
        <div class="thread-badges">
          <span class="status-badge" [ngClass]="getStatusClass(selectedTicket.status)">{{ selectedTicket.status }}</span>
          <span class="priority-badge" [ngClass]="getPriorityClass(selectedTicket.priority)">{{ selectedTicket.priority }}</span>
        </div>
      </div>

      <!-- Empty thread placeholder -->
      <div class="thread-empty-placeholder" *ngIf="!selectedTicket">
        <span class="material-symbols-outlined">chat</span>
        <p>Select a ticket to view the conversation</p>
      </div>

      <!-- Loading thread -->
      <div class="thread-loading" *ngIf="selectedTicket && loadingThread">
        <span class="material-symbols-outlined spin">progress_activity</span>
        <p>Loading conversation...</p>
      </div>

      <!-- Messages Thread -->
      <div class="thread-messages" *ngIf="selectedTicket && !loadingThread">
        <!-- Ticket Info Banner -->
        <div class="thread-info-banner">
          <div class="info-row">
            <span class="material-symbols-outlined">{{ getCategoryIcon(selectedTicket.category) }}</span>
            <strong>{{ selectedTicket.category }}</strong>
          </div>
          <div class="info-row">
            <span class="material-symbols-outlined">schedule</span>
            <span>Opened {{ selectedTicket.created_at | date:'medium' }}</span>
          </div>
          <div class="info-row" *ngIf="selectedTicket.screenshot_url">
            <span class="material-symbols-outlined">attach_file</span>
            <a [href]="selectedTicket.screenshot_url" target="_blank">View Screenshot</a>
          </div>
        </div>

        <!-- Messages -->
        <div class="messages-list">
          <div
            *ngFor="let msg of selectedTicket.messages; trackBy: trackByMsg"
            class="message-bubble"
            [class.msg-user]="msg.sender_type === 'user'"
            [class.msg-admin]="msg.sender_type === 'admin'">
            <div class="msg-avatar">
              <span class="material-symbols-outlined">{{ msg.sender_type === 'user' ? 'person' : 'support_agent' }}</span>
            </div>
            <div class="msg-body">
              <div class="msg-sender">
                {{ msg.sender_type === 'user' ? 'You' : (msg.sender_name || 'Support Team') }}
              </div>
              <div class="msg-text">{{ msg.message }}</div>
              <div class="msg-time">{{ msg.created_at | date:'d MMM y, h:mm a' }}</div>
            </div>
          </div>
          <div #messagesEnd></div>
        </div>

        <!-- Closed Banner -->
        <div class="ticket-closed-banner" *ngIf="selectedTicket.status === 'Closed' || selectedTicket.status === 'Resolved'">
          <span class="material-symbols-outlined">check_circle</span>
          This ticket is {{ selectedTicket.status }}. Open a new ticket if you need further assistance.
          <a routerLink="/support">New Ticket →</a>
        </div>

        <!-- Reply Box -->
        <div class="reply-box" *ngIf="selectedTicket.status !== 'Closed' && selectedTicket.status !== 'Resolved'">
          <textarea
            class="reply-textarea"
            [(ngModel)]="replyText"
            placeholder="Type your reply..."
            rows="3"
            (keydown.control.enter)="sendReply()">
          </textarea>
          <div class="reply-actions">
            <button
              class="btn-close-ticket"
              (click)="requestClose()"
              [disabled]="closingTicket">
              <span class="material-symbols-outlined">{{ closingTicket ? 'progress_activity' : 'archive' }}</span>
              Close Ticket
            </button>
            <button
              class="btn-send-reply"
              (click)="sendReply()"
              [disabled]="!replyText.trim() || sendingReply">
              <span class="material-symbols-outlined" [class.spin]="sendingReply">
                {{ sendingReply ? 'progress_activity' : 'send' }}
              </span>
              {{ sendingReply ? 'Sending...' : 'Send Reply' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
